import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { toast } from "react-toastify";

import { AlertNote } from "../../components/AlertNote";
import { Button } from "../../components/Button";
import { Card } from "../../components/Card";
import { BillingDetailsFields, useBillingDetailsForm } from "./BillingDetailsForm";

// Ajustes → Datos de facturación: datos fiscales de la agencia que Stripe imprime en las facturas.
export function BillingDetailsSettings() {
  const theme = useTheme();
  const { setPageContext } = useOutletContext();
  const form = useBillingDetailsForm();

  useEffect(() => {
    setPageContext({
      title: "Datos de facturación",
      subtitle: "Nombre o razón social, NIF y dirección que aparecen en tus facturas. Si eres autónomo, usa tu nombre y DNI.",
      showTitle: true,
    });
  }, [setPageContext]);

  const handleSave = async () => {
    if (await form.submit()) toast.success("Datos de facturación guardados.");
  };

  if (form.isLoading) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, py: 4 }}>
        <CircularProgress size={18} />
        <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>Cargando datos de facturación…</Typography>
      </Box>
    );
  }

  if (form.isError) {
    return (
      <AlertNote
        variant="danger"
        action={
          <Button variant="outline" size="sm" onClick={() => form.refetch()}>
            Reintentar
          </Button>
        }
      >
        No se han podido cargar los datos de facturación.
      </AlertNote>
    );
  }

  return (
    <Card sx={{ p: 3, gap: 2.5, maxWidth: 760 }}>
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
        Son obligatorios para pagar y se aplican a todas las facturas que se emitan desde ahora; las ya emitidas no
        cambian.
      </Typography>
      <BillingDetailsFields form={form} />
      {form.generalError && <AlertNote variant="danger">{form.generalError}</AlertNote>}
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button onClick={handleSave} disabled={form.saving || !form.dirty}>
          {form.saving ? "Guardando…" : "Guardar"}
        </Button>
      </Box>
    </Card>
  );
}
